import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { IImage } from '../../../../api/images';
import { IProperty } from '../../../../data/entities/property';

import { IItemTypes } from '../../../../data/entities/property/itemTypes';
import { getHydratedProperty } from '../../../../data/selectors';
import { actions as entityActions } from '../../../../data/store';
import { idOrLegacyId } from '../../../../entities/properties/selectors';
import { IThunkDispatch } from '../../../../store/middleware';
import { IState } from '../../../../store/reducer';
import { useDataLoad } from '../../../../view/helpers/hooks';
import { getPhotos } from '../../property/edit/photos/actions';
import { BookingComHelper } from './BookingComHelper';

interface IBookingComHelperContainerProps {
	property: IProperty;
	photos: IImage[];
	itemTypes: IItemTypes;
}

const mapDispatchToProps = (dispatch: IThunkDispatch) => ({
	getPropertyData: (propertyId: number) => dispatch(entityActions.property.getById(propertyId)),
	getPhotoData: (propertyId: number) => dispatch(getPhotos(propertyId)),
	getItemTypes: () => dispatch(entityActions.itemTypes.getItemTypes())
});

const mapStateToProps = (propertyId: number) => (state: IState): IBookingComHelperContainerProps => {
	const property = getHydratedProperty(propertyId, state)!;
	const photos = state.entities.images.byPropertyId[idOrLegacyId(propertyId)] || null;
	const itemTypes = state.data.itemTypes;

	return {
		property,
		photos,
		itemTypes
	};
};

export default () => {
	const params = useParams();
	const propertyId = Number.parseInt(params.id || '', 10);

	const props = {
		...useSelector(mapStateToProps(propertyId)),
		...mapDispatchToProps(useDispatch())
	};

	const propertyLoading = useDataLoad(
		!props.property,
		() => props.getPropertyData(propertyId)
	);

	const imagesLoading = useDataLoad(
		!props.photos,
		async () => {
			// const lookup = await api.legacyLookup.lookUpLegacyId(propertyId);
			return props.getPhotoData(propertyId);
		}
	);

	const itemTypesLoading = useDataLoad(
		!props.itemTypes?.amenity_types,
		() => props.getItemTypes()
	);

	return <BookingComHelper
		{...props}
		loading={propertyLoading || imagesLoading || itemTypesLoading}
	/>;
};
